const toughCookie = require('tough-cookie')
module.exports = toughCookie
